import { BATHROOM_CDN_PATH } from '../../../bathroom-constants';

export const CARD_LIST = [
  {
    image: {
      alt: 'Изображение ванной комнаты без ремонта',
      src: `${BATHROOM_CDN_PATH}/objects/сomplex-repair.jpg/сomplex-repair.jpg`,
    },
    title: 'Комплексный ремонт',
    description: 'Сделаем дизайн-проект, подберём материалы, составим смету и\u00A0выполним все работы\u00A0\u2014 от\u00A0демонтажа до\u00A0финишной отделки',
    link: {
      label: 'Записаться на проектирование',
      href: '/uslugi/remont-vannoy-komnaty/',
      title: 'Ремонт ванной комнаты',
    }
  },
  {
    image: {
      alt: 'Изображение готовой ванной комнаиты',
      src: `${BATHROOM_CDN_PATH}/objects/easy-repair.jpg/easy-repair.jpg`,
    },
    title: 'Лёгкий ремонт',
    description: 'Поможем подобрать комплект мебели и\u00A0сантехники, дополним интерьер уютными аксессуарами.',
    link: {
      label: 'Смотреть комплекты',
      href: '/promo/nabory-mebeli-dlya-vannoy/',
      title: 'Наборы мебели для ванной комнаты',
    }
  },
  {
    image: {
      alt: 'Изображение ванной комнаты с установленной сантехникой',
      src: `${BATHROOM_CDN_PATH}/objects/installation-2.jpg/installation-2.jpg`,
      srcT: `${BATHROOM_CDN_PATH}/objects/installation-2-t.jpg/installation-2-t.jpg`,
    },
    title: 'Установка',
    description: 'Сделаем монтаж любой сантехники\u00A0\u2014 гарантия 12\u00A0месяцев.',
    link: {
      label: 'Вызвать специалиста',
      href: '/uslugi/catalogue/ustanovka-santehniki/',
      title: 'Установка сантехники',
    }
  },
];
